import { FormControl, FormHelperText, Grid } from '@mui/material';
import React from 'react';

// import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx';

// const useStyles = makeStyles(({ palette, ...theme }) => ({
//   root: {
//     // display: 'flex'
//     flexDirection: 'row',
//     alignItems: 'center',
//   }
// }), { name: 'MuiFormControl' })

const GridFormItem = ({ children, error, helperText, half, full }) => {
  let xs = 12,
    sm = 12,
    md = 10;

  if (half) {
    xs = 12;
    sm = 6;
    md = 4;
  }

  // useStyles()

  return (
    <Grid item xs={xs} sm={sm} md={md}>
      <FormControl
        component="fieldset"
        error={Boolean(error)}
        className={clsx(full ? 'w-full' : '')}
      >
        {children}
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </Grid>
  );
};

export default GridFormItem;
